import { useEffect } from "react";
import { useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import { useSoftUIController, setMiniSidenav } from "context";
import { useDispatch, useSelector } from "react-redux";
import { getSearch } from "api/searchSlice";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { collapseItem } from "./styles/sidenavCollapse";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
	const [controller, dispatch] = useSoftUIController();
	const [clickedItem, setClickedItem] = useState(localStorage.getItem('clickedItem') || '');

	const { miniSidenav, transparentSidenav } = controller;
	const location = useLocation();
	const { pathname } = location;
	const collapseName = pathname.split("/").pop();
	
	const dispatcho = useDispatch()
	const closeSidenav = () => setMiniSidenav(dispatch, true);
	const userTheme = useSelector((state) => state.commonSlice.theme);
	const isDark = userTheme === 'dark'
	const handelCleanSearch = () => {
		dispatcho(getSearch(''))
	}

	const currentScope = localStorage.getItem('scope') || '2'
	useEffect(() => {
		function handleMiniSidenav() {
			setMiniSidenav(dispatch, window.innerWidth < 1200);
		}
		window.addEventListener("resize", handleMiniSidenav);
		handleMiniSidenav();
		return () => window.removeEventListener("resize", handleMiniSidenav);
	}, [dispatch, location]);


	const [currentDropDown, setCurrnetOpenDropdown] = useState('')
	const handleClick = (itemKey) => {
		localStorage.setItem('clickedItem', itemKey);
		setClickedItem(itemKey);
	};
	const renderRoutes = routes.map(({ type, name, icon, title, noCollapse, collapse, open, key, route, href, scope }) => {

		let returnValue;
		if (currentScope !== scope) return
		if (type === "collapse" && Array.isArray(collapse)) {

			const hasActiveChild = collapse.some(
				(subItem) => subItem.key === collapseName && subItem.scope === currentScope
			);

			const [openDropdown, setOpenDropdown] = useState(hasActiveChild);

			useEffect(() => {
				if (hasActiveChild) {
					setOpenDropdown(true);
				}
			}, [collapseName]);

			const toggleDropdown = (value) => {
				setCurrnetOpenDropdown((prev) => (prev === value ? '' : value));
			};

			return (
				<SoftBox
					sx={{ background: 'transparent !important' }}
					{...rest} >
					<div onClick={() => toggleDropdown(key)} style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
						<SidenavCollapse
							color={color}
							name={name}
							icon={icon}
							noCollapse={true}
							active={key === collapseName}
							sx={{ marginRight: "0px" }}
						/>

						<div style={{ paddingRight: "8px" }}>
							{currentDropDown === key ? <ExpandLessIcon style={{ color: `${isDark ? '#fff' : '#000'}` }} /> : <ExpandMoreIcon style={{ color: `${isDark ? '#fff' : '#000'}` }} />}
						</div>
					</div>

					{currentDropDown === key && (
						<div style={{ paddingLeft: "1rem", marginTop: "0rem" }}>
							{collapse.map((subItem) => {
								if (currentScope !== subItem.scope) return null;

								return (
									<NavLink
										to={subItem.route}
										key={subItem.key}
										onClick={handelCleanSearch}
										style={{ textDecoration: "none" }}
									>
										<SidenavCollapse
											color={color}
											name={subItem.name}
											icon={subItem.icon}
											onClick={() => handleClick(subItem.key)}
											active={subItem.key === clickedItem}
											noCollapse
										/>
									</NavLink>
								);
							})}
						</div>
					)}
				</SoftBox>
			);
		}

		if (type === "collapse") {
			returnValue = href ? (
				<Link
					href={href}
					key={key}
					target="_blank"
					rel="noreferrer"
					sx={{ textDecoration: "none" }}
					className="glassmorphism-card"
				>

					<SidenavCollapse
						color={color}
						name={name}
						icon={icon}
						active={key == collapseName || (collapseName === "profile" && routes[0].key === key)}
						noCollapse={noCollapse}
						variant='gradient'
					/>
				</Link>
			) : (
				<NavLink to={route} key={key}
					onClick={handelCleanSearch}
				>

					<SidenavCollapse
						color={color}
						key={key}
						name={name}
						icon={icon}
						onClick={() => handleClick(key)}
						active={key == clickedItem || (clickedItem === "profile" && routes[0].key === key)}
						noCollapse={noCollapse}
					/>
				</NavLink>
			);
		} else if (type === "title") {
			returnValue = (
				<SoftTypography
					key={key}
					display="block"
					variant="caption"
					fontWeight="bold"
					textTransform="uppercase"
					opacity={0.6}
					pl={3}
					mt={2}
					mb={1}
					ml={1}
				>
					{title}
				</SoftTypography>
			);
		} else if (type === "divider") {
			returnValue = <Divider key={key} />;
		}

		return returnValue;
	});

	return (
		<SidenavRoot {...rest} variant="permanent" ownerState={{ transparentSidenav, miniSidenav }}>
			<SoftBox p={0} textAlign="center" >
				<SoftBox
					display={{ xs: "block", xl: "none" }}
					position="absolute"
					top={0}
					right={0}
					p={1.625}
					onClick={closeSidenav}
					sx={{ cursor: "pointer" }}
				>
					<SoftTypography variant="h6" color="info">
						<Icon sx={{ fontWeight: "bold" }}>close</Icon>
					</SoftTypography>
				</SoftBox>
				<SoftBox component={NavLink} to="/" display="flex" alignItems="center" justifyContent="center" p={0}>
					{brand && (<SoftBox component="img" className="mainLogo" src={brand} alt="1ONUS" width="6rem" sx={{ display: 'block', margin: '0 auto' }} />)}
				</SoftBox>
			</SoftBox>
			<Divider />
			<List>{renderRoutes}</List>

		</SidenavRoot>
	);
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
	color: "info",
	brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
	color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
	brand: PropTypes.string,
	brandName: PropTypes.string.isRequired,
	routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
